@if (!disableTip) {
  <form (ngSubmit)="submit()" novalidate [formGroup]="form">
    <!--<div>
    <div class="tip-btns-row">
      <ion-fab-button class="btn-tip" size="small" [class.selected]="currentTipSelected == 0" (click)="calculateTip(0)">0%</ion-fab-button>
      <ion-fab-button class="btn-tip" size="small" [class.selected]="currentTipSelected == 15" (click)="calculateTip(15)">15%</ion-fab-button>
      <ion-fab-button class="btn-tip" size="small" [class.selected]="currentTipSelected == 18" (click)="calculateTip(18)">18%</ion-fab-button>
      <ion-fab-button class="btn-tip" size="small" [class.selected]="currentTipSelected == 20" (click)="calculateTip(20)">20%</ion-fab-button>
      <ion-fab-button class="btn-tip" size="small" [class.selected]="currentTipSelected == null" (click)="calculateTip(null)">{{ 'Checkout.Other' | translate }}</ion-fab-button>
    </div>
    <ion-item *ngIf="showTipInput">
      <ion-label position="floating">
        {{ (orderType == 'delivery' ? 'Checkout.TipDelivery' : 'Checkout.Tip') | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input  formControlName="tip" type="number" (ionChange)="submit()"></ion-input>
      <span *ngIf="formErrors.has('tip')" color="danger"><br />{{formErrors.get('tip')}}</span>
    </ion-item>
  </div>-->
  <div class="tip-btns-row">
    @for (cell of tipSetup; track cell) {
      @if (!cell.hideTipCell) {
        <ion-button class="tip-btn" [class.selected]="currentTipSelected == cell.tipCellamount"(click)="calculateTip(cell.tipCellamount)">{{ cell.tipCellamount + '%' }}</ion-button>
      }
    }
    @for (cell of tipCustomSetup; track cell) {
      @if (!cell.hideTipCell) {
        <ion-button class="tip-btn" [class.selected]="currentTipSelected == null" (click)="calculateTip(null)">{{ 'Checkout.Other' | translate }}</ion-button>
      }
    }
    <!--
    <ion-button class="tip-btn" [class.selected]="currentTipSelected == 0" (click)="calculateTip(0)">0%</ion-button>
    <ion-button class="tip-btn" [class.selected]="currentTipSelected == 15" (click)="calculateTip(15)">15%</ion-button>
    <ion-button class="tip-btn" [class.selected]="currentTipSelected == 18" (click)="calculateTip(18)">18%</ion-button>
    <ion-button class="tip-btn" [class.selected]="currentTipSelected == 20" (click)="calculateTip(20)">20%</ion-button>
    <ion-button class="tip-btn" [class.selected]="currentTipSelected == null" (click)="calculateTip(null)">{{ 'Checkout.Other' | translate }}</ion-button>
    -->
  </div>
  @if (showTipInput) {
    <ion-item>
      <ion-label position="floating">
        {{ (orderType == 'delivery' ? 'Checkout.TipDelivery' : 'Checkout.Tip') | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-input  formControlName="tip" type="number" (ionChange)="submit()"></ion-input>
      @if (minTip > 0 && currentTipValue < minTip) {
        <span color="danger" class="errorTextSizing"><br />{{'Checkout.TipMinimum' | translate}}{{ minTip + '$'}}</span>
      }
    </ion-item>
  }
</form>
}